import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import {
  validateBusinessNumber,
  validateExpiryDate,
  validateFile,
} from "pages/formTools";
import { Vendor } from "../..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

const DOCUMENT_RULES = {
  required: true,
  allowedTypes: ["pdf", "image/*"],
  maxSizeMB: 10,
  errorMessage: ta("common.invalid_file"),
};

export const validateBusinessRegistration = (data: Vendor): FieldErrorMap => ({
  businessNumber: validateBusinessNumber({
    name: ta("fields.business_number"),
    value: data.businessNumber ?? "",
    required: true,
  }),

  proofOfInsurance: validateFile({
    name: ta("fields.proof_insurance"),
    file: data.proofOfInsurance,
    ...DOCUMENT_RULES,
  }),

  insuranceExpiryDate: validateExpiryDate({
    name: ta("fields.insurance_expiry"),
    value: data.insuranceExpiryDate,
    required: true,
  }),

  businessLicense: validateFile({
    name: ta("fields.business_license"),
    file: data.businessLicense,
    ...DOCUMENT_RULES,
  }),
});
